<template>
  <div id='design-portfolio-suggestions'>

    <b-table :data='tableData' :row-class="(row, index) => row.suggest === true && 'highlighted'">
      <b-table-column
        v-for='col in columns'
        :label='col.label'
        :field='col.field'
        v-slot='props'>

        {{ format(props, col) }}
      </b-table-column>

      <b-table-column
        label='New Ticker'
        field='new_ticker'
        v-slot='props'>
        
        <a
          :href='getFundLink(props.row.new_ticker)'
          target='_blank'
          rel='noreferrer noopener'>
          {{ props.row.new_ticker }}
        </a>
      </b-table-column>

      <b-table-column
        label='New Values Alignment'
        field='new_composite'
        v-slot='props'>
        {{ props.row.new_composite * 10 }}%
      </b-table-column>
    </b-table>
  </div>
</template>



<script>
  //import SubComponent from '../components/SubComponent'

  export default {
      name: 'component-name',
      components: { /* Subcomponents */ },
      props: ['results', 'targets'],
      data() { return {
        columns: [{
          label: 'Asset Class',
          field: 'ticker__benchmark_description'
        }, {
          label: 'Allocation', pct: true, round: 2,
          field: 'percentage',
        }, {
          label: 'Current Fund Name',
          field: 'ticker__full_name'
        }, {
          label: 'Current Ticker',
          field: 'ticker'
        }, {
          label: 'Current Values Alignment', pct: true, x: 10,
          field: 'composite',
        }, {
          label: 'New Fund Name',
          field: 'new_name'
        }]
      }},
      beforeCreate() {},
      created() {},
      mounted() {},
      updated() {},
      computed: {
        tableData() {
          const records = this.results.base_portfolio_records

          return records.map((record) => {
            return {
              ...record,
              suggest: record.ticker__full_name !== record.new_name
            }
          })
        },
        valueSets() {
            if(!this.targets) return null
            
            const  values = this.targets.values
            return values ? values.join(',') : null
        }
      },
      watch: { /*
          Watches an existing property
          Only runs when the watched property changes */
      },
      methods: {
        format(props, col) {
          let   value  = props.row[col.field]
          const scaled = col.x ? value *= col.x : value
          const text   = col.round ? scaled.toFixed(col.round) : scaled
          return col.pct ? text + '%' : text
        },
        getFundLink(ticker) {
          const  base = '/advisor-dashboard/fund-screener-v2?'
          return base + `ticker=${ticker}&values=${this.valueSets}`
        }
      }
  }
</script>



<style>
  #design-portfolio-suggestions .b-table {
    font-size: 1.25rem;
  }

  #design-portfolio-suggestions tr.highlighted td:nth-last-child(-n + 3) {
    font-weight: bold;
    color: #48c78e;
  }

  #design-portfolio-suggestions a {
    text-decoration: underline;
    color: #363636;
  }

  #design-portfolio-suggestions tr.highlighted a {
    color: #48c78e;
  }
</style>